<template>
  <div class="drawer-wrapper" v-loading.fullscreen.lock="loading">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="dialogVisible" size="50%"
               :before-close="handleClose" direction="rtl">
      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">
            <el-col :span="24" class="mb20">
              <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.name" placeholder="请输入名称" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="图片" prop="image" :label-width="formLabelWidth">
                <ImageUpload v-model="addFrom.image" />
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="跳转地址" prop="link" :label-width="formLabelWidth">
                <el-input v-model="addFrom.link" placeholder="请输入跳转地址" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="状态" :label-width="formLabelWidth">
                <el-radio-group v-model="addFrom.status">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="mb20">
              <el-form-item label="排序" prop="listorder" :label-width="formLabelWidth">
                <el-input-number v-model="addFrom.listorder" :min="0" controls-position="right"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { rcApis } from "@/api/rc";
import { processErrors } from "@/utils/errorHandler";
import ImageUpload from "@/components/ImageUpload";
const api = rcApis();
export default {
  props: ['dialogVisible', "editID"],
  components: { ImageUpload },
  data() {
    return {
      title: "新增",
      formLabelWidth: "120px",
      addFrom: { name: "", image: "", link: "", status: 1, listorder: 0 },
      loading: false,
      isask: false,
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        image: [{ required: true, message: '请上传图片', trigger: 'change' }],
      },
    };
  },
  mounted() {
    if (this.editID != "") {
      this.loading = true;
      api.JumpButtonInfo({ id: this.editID }).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.title = "编辑";
          this.addFrom = res.data;
        } else {
          processErrors(res);
        }
      });
    }
  },
  methods: {
    handleClose() {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },
    AddNone() {
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },
    addPush() {
      if (this.isask) return;
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.isask = true;
          let createText = this.editID == "" ? "创建成功" : "修改成功";
          if (this.editID != "") this.addFrom.id = this.editID;
          api.JumpButtonEdit(this.addFrom).then(res => {
            this.isask = false;
            this.loading = false;
            if (res.code == 0) {
              this.$message.success(createText);
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          });
        } else {
          return false;
        }
      });
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content { height: calc(100% - 80px); overflow-y: auto; margin-top: 20px; overflow-x: hidden; }
.demo-drawer__footer { position: absolute; bottom: 0; left: 0; width: 100%; padding: 10px; text-align: center; }
.demo-drawer__footer .el-button { margin: 0 10px; width: calc(50% - 20px); }
</style>
